import { render, staticRenderFns } from "./fqGame.vue?vue&type=template&id=12276f16"
import script from "./fqGame.vue?vue&type=script&lang=js"
export * from "./fqGame.vue?vue&type=script&lang=js"
import style0 from "./fqGame.vue?vue&type=style&index=0&id=12276f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports